export type MenuSpacerConfig = {
  id: string;
  spaceType: 'simple' | 'double';
};

export type MenuItemType = 'common' | 'basket' | 'wishlist';

export type MenuItemConfig = MobileNavigationConfig & {
  label: string;
  highlightCategory: boolean;
  path: string;
  hideMenu: boolean;
  icon?: string;
  type: MenuItemType;
};

export type MobileNavigationConfig = {
  id: string;
  ':items': Record<string, MenuSpacerConfig | MenuItemConfig>;
  ':itemsOrder': Array<string>;
};

export type MobileNavigationItem = {
  id: string;
  label: string;
  title: string;
  href?: string;
  linkParameters?: string;
  spacing?: 's' | 'm' | 'l';
  subItems?: Array<MobileNavigationItem>;
  active?: boolean;
  icon?: string;
  image?: string;
  emphasized?: boolean;
  type: MenuItemType;
};

export type MobileNavigationSearchConfig = {
  enabled: boolean;
  brandsParentLink?: string;
  categoriesParentLink?: string;
};

export type MobileNavigationAccountConfig = {
  enabled: boolean;
  login: { actionUri: string };
  registration: { link: string };
  accountMenu: { items: Array<{ label: string; link: string; active: boolean }> };
};

export type MobileNavigationComponentConfig = {
  search: Omit<MobileNavigationSearchConfig, 'enabled'>;
  account: Omit<MobileNavigationAccountConfig, 'enabled'>;
};
